// extracted by mini-css-extract-plugin
export default {"sideNav":"Shell_sideNav__YE3jE","sideNavTop":"Shell_sideNavTop__2siVJ","sideNavBottom":"Shell_sideNavBottom__Xo3wL"};